const depositAmountStringBuilder = (defaultDepositAmountPercentage: number, depositType?: Tours.V2OfferDepositType, depositAmount?: number) => {
  const baseText = 'Secure with a'

  if (depositType === 'flat') {
    return { full: `${baseText} $${depositAmount}/person deposit`, short: `$${depositAmount}/person` }
  }

  if (depositType === 'percentage') {
    return { full: `${baseText} ${depositAmount}% deposit`, short: `${depositAmount}%` }
  }

  return { full: `${baseText} ${defaultDepositAmountPercentage}% deposit`, short: `${defaultDepositAmountPercentage}%` }
}

export default depositAmountStringBuilder
